import capi from '../capi/instance';

import { CommonRes } from '../../types/index';

export const DEFAULT_TIMBRE_CATEGORY = '0'; // 默认分类
export const EMOTIONAL_TIMBRE_CATEGORY = '2'; // 多情感分类
export const ENG_TIMBRE_CATEGORY = '8'; // 外语分类
export const CUSTOM_TIMBRE_CATEGORY = '1'; // 定制分类

export interface GetTimbreListReq {
  offset: number;
  limit: number;
  timbreCategory?: string;
  virtualmanTypeCode?: string;
  driverType?: string;
  virtualmanCode?: string; // 数智人code，筛选形象性别用
  virtualmanResourceId?: number;
  timbreFilter?: {
    timbreName?: string;
    timbreGender?: number;
    timbreSelectedCode?: string;
    timbreDesc?: string;
    timbreLanguageLabel?: string; // 全部:空, 单语种:monolingual, 多语种:multilingual
    timbreSelectedLanguage?: string;
    timbreClassification?: number; // 新增音色类型数组（1-公共音色、2-定制音色、3-三方音色、4-收藏音色）
    timbreAge?: number; // NEW：新增年龄字段（1-少年、2-青年、3-中年、4-老年）。注意只对公共音色生效
    thirdSource?: string; // NEW:三方音色的来源。注意只对三方音色生效 （微软-azure，公有云-tencent）
    thirdType?: number; // NEW:三方音色类别，0-全部 1-公共 2-用户自己导入的
  };
}

interface GetTimbreListRes extends CommonRes {
  timbres: {
    timbreCode: string;
    timbreName: string;
    timbreValue: string;
    timbreUrl: string;
    timbreDesc: string;
    timbreSource: string;
    timbreType: string;
    isRecommend: number;
    timbreCategory: string;
    platformSource: number;
    timbreSpeed: string[];
    supportVirtualmanTypeCodes: string[];
    supportDriverTypes: string[];
    timbreAssetsType: number;
    timbreGender: number;
    emotionalStyles: {
      code: string;
      name: string;
    }[];
    supportLanguages: {
      code: string;
      name: string;
    }[];
    language: string | 'chi' | 'eng' | 'jp' | 'thai' | 'ko' | 'ta_sg' | 'ta_my'; // chi-中文 eng-英文 jp-日语 thai-泰语 ko-朝鲜语 ta_sg 新加坡 ta_my 马来西亚,
    speaker: string;
    labels: string[];
    timbreClassification: number;
    timbreAge: number;
    thirdSource: string;
    isCollected: number;
    timbreTag: string;
  }[];
  totalCount: number;
  limit: number;
  offset: number;
}

export interface TimbreSetting {
  volume?: number;
  emotionIntensity?: number;
  emotionCategory?: string;
  timbreLanguage?: string;
  platformSource?: number;
  timbreCode?: string;
}
interface SaveTtsAuditionReq {
  sentence: string;
  speedCode: string;
  timbreCode: string;
  timbreCategory?: string;
  timbreSource?: number;
  affectiveStyle?: string;
  affectiveLevel?: number;
  volume?: number;
  ticket: string;
  randomData: string;
}

interface SaveTtsAuditionRes extends CommonRes {
  auditionKey: string;
}

interface DescribeTtsAuditionDetailReq {
  auditionKey: string;
}

interface DescribeTtsAuditionDetailRes extends CommonRes {
  audio: string;
  status: number;
  reason: string;
}

// 用户音色列表查询
export const getTimbreList = async (data: GetTimbreListReq) => {
  const res = await capi<GetTimbreListReq, GetTimbreListRes>('DescribeTimbreList', data);
  return res;
};

// 相册音色列表查询
export const getProtoTimbreList = async (data: GetTimbreListReq) => {
  const res = await capi<GetTimbreListReq, GetTimbreListRes>('DescribeVirtualmanProtoTimbreList', data);
  return res;
};

// 生成试听key
export const getAuditionKey = async (data: SaveTtsAuditionReq) => {
  const res = await capi<SaveTtsAuditionReq, SaveTtsAuditionRes>('SaveTtsAudition', data);
  return res;
};

// 查询试听生成进度
export const getAudition = async (data: DescribeTtsAuditionDetailReq) => {
  const res = await capi<DescribeTtsAuditionDetailReq, DescribeTtsAuditionDetailRes>('DescribeTtsAuditionDetail', data);
  return res;
};
interface collectTimbreReq {
  timbreKey: string;
  timbreClassification: string;
}
interface collectTimbreRes {
  timbreKey: string;
  collectStatus: number;
}
// 用户音色收藏/取消
export const collectTimbre = async (data: collectTimbreReq) => {
  const res = await capi<collectTimbreReq, collectTimbreRes>('CollectTimbre', data);
  return res;
};
interface describeThirdPartySecretReq {
  source: string;
  keyType: number;
}
interface describeThirdPartySecretRes {
  thirdPartySecretList: {
    source: string;
    keyType: number;
    secretInfo: {
      appId?: string;
      secretId?: string;
      secretKey?: string;
      subscriptionKey?: string;
      region?: string;
    };
  }[];
}
// 用户密钥查询
export const describeThirdPartySecret = async (data: describeThirdPartySecretReq) => {
  const res = await capi<describeThirdPartySecretReq, describeThirdPartySecretRes>('DescribeThirdPartySecret', data);
  return res;
};

type OperateThirdPartyTimbreReq = {
  operateType: string; // 增删改查统一为一个接口，枚举值：insert/update/delete
  source?: string; // 三方音色来源（目前包括tencent/azure）
  timbreID?: string;
  timbreName?: string;
  timbreType?: string;
  gender?: number; // 1-男；2-女
  timbreKey?: string; // 音色key，删除和更新时需要传入
};

interface OperateThirdPartyTimbreRes extends CommonRes {
  timbreKey?: string;
}
// 操作三方音色
export const operateThirdPartyTimbre = async (data: OperateThirdPartyTimbreReq) => {
  const res = await capi<OperateThirdPartyTimbreReq, OperateThirdPartyTimbreRes>('OperateThirdPartyTimbre', data);
  return res;
};
interface GetTimbreDetailReq {
  timbreCode: string;
}
interface GetTimbreDetailRes {
  timbre: {
    timbreCode: string;
    timbreName: string;
    timbreValue: string;
    timbreUrl: string;
    timbreDesc: string;
    timbreSource: string;
    timbreType: string;
    isRecommend: number;
    timbreCategory: string;
    platformSource: number;
    timbreSpeed: string[];
    supportVirtualmanTypeCodes: string[];
    supportDriverTypes: string[];
    timbreAssetsType: number;
    timbreGender: number;
    emotionalStyles: {
      code: string;
      name: string;
    }[];
    supportLanguages: {
      code: string;
      name: string;
    }[];
    language: string | 'chi' | 'eng' | 'jp' | 'thai' | 'ko' | 'ta_sg' | 'ta_my'; // chi-中文 eng-英文 jp-日语 thai-泰语 ko-朝鲜语 ta_sg 新加坡 ta_my 马来西亚,
    speaker: string;
    labels: string[];
    timbreClassification: number;
    timbreAge: number;
    thirdSource: string;
    isCollected: number;
    timbreTag: string;
  }
}
// 用户音色查询
export const getTimbreDetail = async (data: GetTimbreDetailReq) => {
  const res = await capi<GetTimbreDetailReq, GetTimbreDetailRes>('GetTimbreDetail', data);
  return res;
};
